<template>
  <div class="resource_map_wrap" :style="`height: ${windowHeight - 120}px;`">
    <div class="resource_map_box">
      <div class="resource_map_line" :key="gradeItem.gradeLevel" v-for="gradeItem in dataList">
        <div class="map_title">{{gradeItem.gradeName}}</div>
        <div class="grade_box">
          <div class="grade_item" :title="item.atlasName" @click="toSubjectIndex(item.id, item.atlasName)"
               :key="item.id" v-for="item in gradeItem.gradeAtlasList">
            <img :src="item.logoUrl" alt="">
            <div>{{item.atlasName}}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import windowResize from '@/mixins/windowResize'
  import {getSysAutonomicResourceList} from '@/api/resourceMap'

  export default {
    name: "resourceMapIndex",
    data() {
      return {
        dataList: []
      }
    },
    mixins: [windowResize],
    created() {
      this.getSysAutonomicResourceList()
    },
    methods: {
      toSubjectIndex(subjectId, atlasName) {
        this.$router.push({path: 'resourceSubjectIndex', query: {subjectId: subjectId, atlasName: atlasName}})
      },
      getSysAutonomicResourceList() {
        getSysAutonomicResourceList().then(data => {
          this.dataList = data;
        })
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import './../../../styles/mixin';

  .resource_map_wrap {
    padding: 12px;
    @include scrollBar;
    .resource_map_box{
      .resource_map_line{
        .map_title{
          height: 20px;
          line-height: 20px;
          margin-top: 15px;
          margin-left: 15px;
          padding-left: 8px;
          border-left: 4px solid #409EFF;
          font-weight: bold;
        }
        .grade_box{
          @include clearfix;
          .grade_item{
            float: left;
            width: 110px;
            margin-top: 20px;
            margin-left: 18px;
            overflow: hidden;
            cursor: pointer;
            img{
              display: block;
              width: 80px;
              height: 80px;
              margin: 0 auto;
              border-radius: 5px;
              overflow: hidden;
            }
            div{
              height: 30px;
              line-height: 30px;
              text-align: center;
              font-size: 14px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/study/resourceMap/resourceMapIndex.vue